import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { DatePipe } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../components/table/table.component';
import { Observable, of, switchMap, tap } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../environments/environment';
import { MyMonitoringService } from '../../services/logging.service';
import { DialogModule } from 'primeng/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { AllRecordsService } from '../../services/allRecordsService';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ButtonComponent } from '../components/button/button.component';
import { ApiService } from '../../services/apiservice';
import { DatePickerModule } from 'primeng/datepicker';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
@Component({
  selector: 'app-call-by-analyst-data',
  templateUrl: './callbyanalyst.component.html',
  standalone: true,
  styleUrl: './callbyanalyst.component.scss',
  imports: [DialogModule, DatepickerComponent, TableModule, DatePickerModule, ToastModule, TagModule, SelectModule, ButtonModule, InputTextModule, FormsModule, TableComponent, DropdownComponent, ProgressSpinnerModule, SelectModule, ConfirmPopupModule],
  providers: [MessageService, AllRecordsService, DatePipe, ConfirmationService]
})
export class CallByAnalystStatusComponent implements OnInit {
  @ViewChild('tblConfig') tblConfig!: TableComponent;

  router: any;
  param: any;
  processMessage: string = "";
  lsNorthDataColumns: any[] = [];
  criticalLoadDataCommentColumns: any[] = [];
  selectedItems: any[] = [];
  AppKeyValuePairs: any[] = [];
  actionButtons: any = [];
  isLoading: boolean = false;

  totalRecords: number = 0;
  pageNumber: number = 1;
  pageSize: number = 10;

  dialogVisible: boolean = false;
  cellValue: any[] = ['', ''];
  commentTable: any[] = [];
  comments$!: Observable<any[]>;
  selectedRow: any;
  txtComment: any;
  user: any;
  analystStatusOptions: SelectItem[] = [];
  schuduledDateOptions: SelectItem[] = [];
  dispatchViewOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  districtsMainCollection: any;
  selectedAnalystStatus: any;
  selectedScheduledDate: string = "";
  selectedDispatchView: string = "";
  selectedType: any;
  selectedDateTaken: string = "";
  allDistrictData: any[] = [];
  sortField: string = "SchedDate";
  sortOrder: number = 0;
  searchText: any = "";
  filteredData$!: Observable<any[]>;
  queryParamData: any = {};
  selectDate: string = "Sched Date";


  constructor(
    private route: ActivatedRoute,
    private recordsService: AllRecordsService,
    private messageService: MessageService,
    private redirectRoute: Router,
    private monotoringService: MyMonitoringService, private datePipe: DatePipe,
    private confirmationService: ConfirmationService, private apiService: ApiService
  ) {
    this.router = route;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      this.tblConfig.searchValue = this.param;
    });


    const temp = JSON.parse(sessionStorage.getItem("queryData")!);
    if (temp) {
      this.selectedAnalystStatus = temp.data.Analyst_Status;

      this.selectedScheduledDate = temp.data.Sched_Date;
      this.selectedType = temp.data.Type;


      this.getselectedAnalystStatusDetails();
      sessionStorage.removeItem("queryData")

    }

    this.LoadHeader();
    this.LoadDistrictDetails();

  }

  showDialog() {
    this.dialogVisible = true;
  }


  LoadHeader(): void {
    this.processMessage = environment.appMessages.loadingMesage;

    this.lsNorthDataColumns = [
      { "field": "AnalystStatus", "header": "ANALYST STATUS", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "SchedDate", "header": "SCHED DATE", "filter": true, "isSorting": true, "width": "10%" },

      { "field": "Type", "header": "TYPE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "District", "header": "DISTRICT", "filter": true, "isSorting": true, "width": "10%" },


      { "field": "State", "header": "STATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "City", "header": "CITY", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "House", "header": "HOUSE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Street", "header": "STREET", "filter": true, "isSorting": true, "width": "10%" },
      {
        "field": "Update", "header": "ACTION", "filter": false, "isSorting": false, "width": "10%", type: "action", isClickable: 'true',
        onclick: this.handleClick.bind(this)
      }
    ];


    this.commentTable = [
      { "field": "message", "header": "USER COMMENTS", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdUser", "header": "CREATE BY", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdDate", "header": "CREATE DATETIME", "filter": true, "isSorting": true, "width": "5%" },
    ]

  }

  handleClick(rowData: any): void {
    this.redirectRoute.navigate(['/order-entry', rowData.CCR_ID]);

    const data = {

      Sched_Date: this.selectedScheduledDate,
      Analyst_Status: this.selectedAnalystStatus,
      Type: this.selectedType
    }

    const temp = {
      data,
      from: "/byanalyststatus"
    }

    sessionStorage.setItem("queryData", JSON.stringify(temp))
  }

  uniqueData(data: any) {
    const uniqueData = data.filter((value: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t.label === value.label && t.value === value.value
      ))
    );

    const sortedData = uniqueData.sort((a: any, b: any) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });

    return sortedData;
  }

  onDateTakenChange(event: any) {
    this.selectedDateTaken = event;

  }


  LoadDistrictDetails(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;

    this.apiService.groupId().pipe(
      switchMap(groupId => this.recordsService.getDistricts(groupId))
    ).subscribe({
      next: (data: any) => {
        this.districtsMainCollection = data?.Payload;
        this.analystStatusOptions = this.uniqueData(data?.Payload.AnalystStatusData?.map((district: any) => ({
          label: district.Value.trim(),
          value: district.Value
        })));

        this.typeOptions = this.uniqueData(data?.Payload.OrderTypeData.map((district: any) => ({
          label: district.Value.trim(),
          value: district.Value
        })));

        this.isLoading = false;
      },
      error: error => {
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallByAnalystStatusComponent.LoadDistrictDetails', message: error }, SeverityLevel.Error);
        this.isLoading = false;
      },
      complete: () => { this.isLoading = false; }
    });
  }
  sortedData(data: any[]) {
    return data.sort((a, b) => {
      const dateA = new Date(a.value);
      const dateB = new Date(b.value);

      return dateA.getTime() - dateB.getTime(); // Compare the numeric time values of the Date objects
    });
  }
  removeDuplicateValues(data: any) {

    return data.reduce((acc: any, current: any) => {
      if (!acc.some((item: any) => item.label === current.label)) {
        acc.push(current);
      }
      return acc;
    }, []);
  }

  updateDropdownValuesForLoad() {

    const tempData = this.districtsMainCollection?.filter((item: any) => item.AnalystStatus?.trim() === this.selectedAnalystStatus?.trim());
    const scheduledDta = this.uniqueData(tempData.map((district: any) => ({
      label: this.datePipe.transform(new Date(district.SchedDate.trim()), "MM-dd-yyyy")?.toString(),
      value: district.SchedDate?.trim()?.toString()
    })));

    const sortedScheduledData = this.sortedData(scheduledDta);
    this.schuduledDateOptions = this.removeDuplicateValues(sortedScheduledData)?.reverse();

    const tempData1 = this.districtsMainCollection?.filter((item: any) => item.AnalystStatus?.trim() === this.selectedAnalystStatus?.trim() && item.SchedDate?.trim() === this.selectedScheduledDate?.trim());
    this.typeOptions = this.uniqueData(tempData1.map((district: any) => ({
      label: district.Type.trim(),
      value: district.Type
    })));



  }

  updateDropdownValues() {
    if (this.selectedAnalystStatus !== "" && this.selectedScheduledDate === "" && this.selectedType === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.AnalystStatus?.trim() === this.selectedAnalystStatus?.trim());
      const scheduledDta = this.uniqueData(tempData.map((district: any) => ({
        label: this.datePipe.transform(new Date(district.SchedDate.trim()), "MM-dd-yyyy")?.toString(),
        value: district.SchedDate?.trim()?.toString()
      })));

      const sortedScheduledData = this.sortedData(scheduledDta);
      this.schuduledDateOptions = this.removeDuplicateValues(sortedScheduledData)?.reverse();

    }


    if (this.selectedAnalystStatus !== "" && this.selectedScheduledDate !== "" && this.selectedType === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.AnalystStatus?.trim() === this.selectedAnalystStatus?.trim() && item.SchedDate?.trim() === this.selectedScheduledDate?.trim());
      this.typeOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.Type.trim(),
        value: district.Type
      })));

    }

  }

  getselectedAnalystStatusDetails(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;

    this.apiService.groupId().pipe(
      switchMap(groupId => {
        const payload = {
          Sched_Date: this.selectedScheduledDate === "" ? null : this.selectedScheduledDate,
          Analyst_Status: this.selectedAnalystStatus === "" ? null : this.selectedAnalystStatus,
          Type: this.selectedType === "" ? null : this.selectedType,
          UserID: sessionStorage.getItem('userId'),
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          SortField: this.sortField,
          SortOrder: this.sortOrder,
          SearchText: this.searchText,
          groupId: groupId,
          HasAnalystStatus: true
        }
      return this.recordsService.getRecordDetails(payload);
    })
    ).subscribe({
      next: (data: any) => {
        const updatedData = data?.Payload.Data?.map((item: any) => {
          return {
            ...item,
            SchedDate: this.datePipe.transform(new Date(item.SchedDate.trim()), "MM-dd-yyyy")?.toString()
          }
        });

        this.filteredData$ = of(updatedData);
        this.totalRecords = data?.Payload?.TotalRecords;

        if (data?.Payload?.Data?.length === 0) {
          const errMsg = environment.appMessages.noData
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: errMsg, life: environment.appSettings.snakbarLife });
        }
        if (this.queryParamData) {
          this.queryParamData = undefined;
          this.isLoading = false;

        }
      },
      error: error => {
        this.isLoading = false;
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallByAnalystStatusComponent.getselectedAnalystStatusDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;

      }
    })


  }

  onCellClicked(event: any[]) {
    this.isLoading = true;
    this.cellValue = event;
    this.selectedRow = event[1];

  }


  onCancelCommentClicked() {
    this.txtComment = "";
    this.dialogVisible = false;
  }

  onSaveCommentClicked() {

    this.isLoading = true;
    const cmt = { bqUniqueId: this.selectedRow.bqUniqueId, message: this.txtComment, createdUser: this.user, createdDate: Date() };
    if (cmt === null || cmt === undefined) {
      this.messageService.add({ severity: 'warning', summary: 'warning', detail: environment.appMessages.noChangesFound, life: environment.appSettings.snakbarLife });
      return;
    }

    this.processMessage = environment.appMessages.savinggMesage;
    this.isLoading = false;
  }

  reload() {
    this.tblConfig.clear();
    this.selectedItems = [];
    this.LoadHeader();
  }

  onReloadClicked() {
    this.reload();
  }

  onAnalystStatusChange(event: any) {
    this.selectedAnalystStatus = event;

  }


  onScheduledDateChange(event: any) {
    this.selectedScheduledDate = event;
  }

  onDispatchViewChange(event: any) {
    this.selectedDispatchView = event;

  }
  getSearchDisabledStatus() {
    return this.selectedAnalystStatus === "" || this.selectedScheduledDate === "" || this.selectedType === ""
  }

  handlePageChange(event: any): void {
    this.pageNumber = event.page;
    this.pageSize = event.pageSize;
    this.getselectedAnalystStatusDetails();
  }

  onTypeChange(event: any) {
    this.selectedType = event;
  }

  onSearch(): void {
    this.pageNumber = 1
    this.tblConfig.resetPage();
    this.getselectedAnalystStatusDetails();
  }

  onClear(): void {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {

        this.selectedScheduledDate = "";
        this.selectedAnalystStatus = "";
        this.selectedType = "";
        this.sortField = "";
        this.sortOrder = 1;
        this.searchText = "";
        this.filteredData$ = of([]);
        this.totalRecords = 0
      },
      reject: () => {
      }

    });







  }
  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.pageNumber = 1
    this.tblConfig.resetPage();
    this.searchText = event.searchText;
    this.getselectedAnalystStatusDetails();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.getselectedAnalystStatusDetails();
  }
}





